import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-three-column',
  templateUrl: './three-column.component.html',
  styleUrls: ['./three-column.component.css']
})
export class ThreeColumnComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
